import { AnyAction } from "redux";
import { GET_VENDORS_BY_LOCATION_FAILURE, GET_VENDORS_BY_LOCATION_REQUEST, GET_VENDORS_BY_LOCATION_SUCCESS, RESET_VENDORS_BY_LOCATION_STATE } from "../constants/vendorsByLocation.constants";

const initialState = {
    loading: false,
    data: [],
    error: '',
    count: 0,
};

export const vendorsByLocationReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_VENDORS_BY_LOCATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
            };

        case GET_VENDORS_BY_LOCATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };

        case GET_VENDORS_BY_LOCATION_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        case RESET_VENDORS_BY_LOCATION_STATE:
            return {
                ...state,
                data: [],
                error: '',
            };

        default:
            return state;
    }
}
